import {
  ExceptionAction,
  ExceptionApiActionNames,
  ExceptionLinkActionNames,
  ExceptionReference,
  ExceptionReferenceTypes
} from '@/redux/slices/slice_types';
import { convertFromSnakeCase } from '@/_utils/utils';

// Maps action names to the entities they operate on.
const ActionNameToReferenceTypeMap = {
  [ExceptionLinkActionNames.GoToJob]: ExceptionReferenceTypes.Job,
  [ExceptionLinkActionNames.GoToOrder]: ExceptionReferenceTypes.Order,
  [ExceptionLinkActionNames.GoToTask]: ExceptionReferenceTypes.Task,
  [ExceptionLinkActionNames.GoToAsset]: ExceptionReferenceTypes.Asset,
  [ExceptionLinkActionNames.GoToIngest]: ExceptionReferenceTypes.Ingest,
  [ExceptionApiActionNames.CancelJob]: ExceptionReferenceTypes.Job,
  [ExceptionApiActionNames.RestartJob]: ExceptionReferenceTypes.Job,
  [ExceptionApiActionNames.RetryRallyJob]: ExceptionReferenceTypes.Job
};

export const getActionButtonLabel = (action: ExceptionAction, references: ExceptionReference[]) => {
  const actionName = action.name;
  const label = convertFromSnakeCase(actionName);

  // const reference = references.find((ref) => ref.type === ActionNameToReferenceTypeMap[actionName]);
  // const referenceHid = reference?.hid;

  return label;
};

export const getActionConfirmationDialogMessage = (actionName: ExceptionAction['name']) => {
  return `Are you sure you want to ${actionName.replace(/_/g, ' ')}?`;
};

export const getActionSuccessMessage = (actionName: ExceptionApiActionNames): string | undefined => {
  const actionNameToMessageMap = {
    [ExceptionApiActionNames.CancelJob]: 'Job cancelled',
    [ExceptionApiActionNames.RestartJob]: 'Job restarted',
    [ExceptionApiActionNames.RetryRallyJob]: 'Retrying Rally job'
  };
  return actionNameToMessageMap[actionName];
};
